import { nanoid } from "nanoid";

export const decodeSegment = (segmentation) => {
  var s = segmentation.counts;
  var p = 0;
  var cnts = [];
  var m = 0;
  while (s[p]) {
    var x = 0;
    var k = 0;
    var more = 1;
    while (more) {
      const c = s[p].charCodeAt(0) - 48;
      x |= (c & 0x1f) << (5 * k);
      more = c & 0x20;
      p++;
      k++;
      if (!more && c & 0x10) {
        x |= -1 << (5 * k);
      }
    }
    if (m > 2) {
      x += cnts[m - 2];
    }
    m++;
    cnts.push(x);
  }

  //console.log('segmentation', segmentation, 'cnts', cnts)
  var maskArea = convertToMaksArea(cnts);

  return {
    segmentation: "",
    maskArea: maskArea,
    id: nanoid(),
    width: segmentation.size[1],
    height: segmentation.size[0],
    area: maskArea.filter((m) => m > 0).length,
  };
};

function convertToMaksArea(rleArray) {
  var maskArea = [];
  for (let i = 0; i < rleArray.length; i += 2) {
    maskArea = maskArea.concat(Array(rleArray[i]).fill(0));
    if (i + 1 !== rleArray.length) {
      maskArea = maskArea.concat(Array(rleArray[i + 1]).fill(1));
    }
  }
  return maskArea;
}

export function arrayToImageData(input, width, height, color = [255, 0, 0, 100]) {
  const [r, g, b, a] = color;
  const arr = new Uint8ClampedArray(4 * width * height).fill(0);

  var rowWiseData = new Array(width * height).fill(0);

  for (let i = 0; i < input.length; i++) {
    let x = parseInt(i / height);
    let y = i % height;

    let row_index = y * width + x;
    rowWiseData[row_index] = input[i];
  }

  for (let i = 0; i < rowWiseData.length; i++) {
    //input data is column-wise, need to convert it to row-wise

    if (rowWiseData[i] > 0.0) {
      arr[4 * i + 0] = r;
      arr[4 * i + 1] = g;
      arr[4 * i + 2] = b;
      arr[4 * i + 3] = a;
    }
  }
  return new ImageData(arr, width, height);
}

export function Border(imageData) {
  var nPixels = imageData.data.length;

  var size = this.getAttr("borderSize") || 0;

  // - first set correct dimensions for canvases
  canvas.width = imageData.width;
  canvas.height = imageData.height;

  tempCanvas.width = imageData.width;
  tempCanvas.height = imageData.height;

  // - the draw original shape into temp canvas
  tempCanvas.getContext("2d").putImageData(imageData, 0, 0);

  // - then we need to remove alpha chanel, because it will affect shadow (transparent shapes has smaller shadow)
  removeTransparency(tempCanvas);

  var ctx = canvas.getContext("2d");
  var color = this.getAttr("borderColor") || "black";

  // 3. we will use shadow as border
  // so we just need apply shadow on the original image
  ctx.save();
  ctx.shadowColor = color;
  ctx.shadowBlur = size;
  ctx.drawImage(tempCanvas, 0, 0);
  ctx.restore();

  // - Then we will dive in into image data of [original image + shadow]
  // and remove transparency from shadow
  var tempImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  var SMOOTH_MIN_THRESHOLD = 3;
  var SMOOTH_MAX_THRESHOLD = 10;

  let val, hasValue;

  var offset = 3;

  for (var i = 3; i < nPixels; i += 4) {
    // skip opaque pixels
    if (imageData.data[i] === 255) {
      continue;
    }

    val = tempImageData.data[i];
    hasValue = val !== 0;
    if (!hasValue) {
      continue;
    }
    if (val > SMOOTH_MAX_THRESHOLD) {
      val = 255;
    } else if (val < SMOOTH_MIN_THRESHOLD) {
      val = 0;
    } else {
      val = ((val - SMOOTH_MIN_THRESHOLD) / (SMOOTH_MAX_THRESHOLD - SMOOTH_MIN_THRESHOLD)) * 255;
    }
    tempImageData.data[i] = val;
  }

  // draw resulted image (original + shadow without opacity) into canvas
  ctx.putImageData(tempImageData, 0, 0);

  // then fill whole image with color (after that shadow is colored)
  ctx.save();
  ctx.globalCompositeOperation = "source-in";
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.restore();

  // then we need to copy colored shadow into original imageData
  var newImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  var indexesToProcess = [];
  for (var i = 3; i < nPixels; i += 4) {
    var hasTransparentOnTop = imageData.data[i - imageData.width * 4 * offset] === 0;
    var hasTransparentOnTopRight = imageData.data[i - (imageData.width * 4 + 4) * offset] === 0;
    var hasTransparentOnTopLeft = imageData.data[i - (imageData.width * 4 - 4) * offset] === 0;
    var hasTransparentOnRight = imageData.data[i + 4 * offset] === 0;
    var hasTransparentOnLeft = imageData.data[i - 4 * offset] === 0;
    var hasTransparentOnBottom = imageData.data[i + imageData.width * 4 * offset] === 0;
    var hasTransparentOnBottomRight = imageData.data[i + (imageData.width * 4 + 4) * offset] === 0;
    var hasTransparentOnBottomLeft = imageData.data[i + (imageData.width * 4 - 4) * offset] === 0;
    var hasTransparentAround =
      hasTransparentOnTop ||
      hasTransparentOnRight ||
      hasTransparentOnLeft ||
      hasTransparentOnBottom ||
      hasTransparentOnTopRight ||
      hasTransparentOnTopLeft ||
      hasTransparentOnBottomRight ||
      hasTransparentOnBottomLeft;

    // if pixel presented in original image - skip it
    // because we need to change only shadow area
    if (imageData.data[i] === 255 || (imageData.data[i] && !hasTransparentAround)) {
      continue;
    }
    if (!newImageData.data[i]) {
      // skip transparent pixels
      continue;
    }
    indexesToProcess.push(i);
  }

  for (var index = 0; index < indexesToProcess.length; index += 1) {
    var i = indexesToProcess[index];

    var alpha = imageData.data[i] / 255;

    if (alpha > 0 && alpha < 1) {
      var aa = 1 + 1;
    }
    imageData.data[i] = newImageData.data[i];
    imageData.data[i - 1] = newImageData.data[i - 1] * (1 - alpha) + imageData.data[i - 1] * alpha;
    imageData.data[i - 2] = newImageData.data[i - 2] * (1 - alpha) + imageData.data[i - 2] * alpha;
    imageData.data[i - 3] = newImageData.data[i - 3] * (1 - alpha) + imageData.data[i - 3] * alpha;

    if (newImageData.data[i] < 255 && alpha > 0) {
      var bb = 1 + 1;
    }
  }
}
